import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';

export default mutatorAction(
    'SELECT_FEEDBACK_AREA',
    (subject: string, emailAddresses: string[]) => {
        store.subjectArea = subject;
        store.emailAddresses = emailAddresses;
    }
);
